import React from "react";

import type { NormalisedProduct } from "@app/scripts/types";

type Props = {
  product: NormalisedProduct;
  qty?: number;
  lineItem?: any;
};

export const ProductPrice: React.FC<Props> = ({ product, qty, lineItem }) => {
  const onSale = product.compare_at_price && product.price < product.compare_at_price;

  return (
    <div className="price">
      <div className="price__container">
        {!onSale ? (
          <div className="price__regular">
            <span className="visually-hidden visually-hidden--inline">Regular price</span>
            <span className="price-item price-item--regular">
              {"$"}
              {(lineItem?.final_line_price ? lineItem?.final_line_price / 100 : product.price)?.toFixed(2)}
            </span>
          </div>
        ) : (
          <div className="price__sale">
            <span className="price-item price-item--sale">
              {"$"}
              {(lineItem?.final_line_price ? lineItem?.final_line_price / 100 : product.price)?.toFixed(2)}
            </span>
            <span className="visually-hidden visually-hidden--inline">Regular price</span>
            <span>
              <s className="price-item price-item--regular">
                {"$"}
                {(qty && product.compare_at_price ? product.compare_at_price * qty : product.compare_at_price)?.toFixed(
                  2
                )}
              </s>
            </span>
            <span className="visually-hidden visually-hidden--inline">Sale price</span>
          </div>
        )}
      </div>
    </div>
  );
};
